/** The "possibly an agent" mark on a listing labelled owner by its site.
 *
 *  The weekly realtor scoring (backend ops/scripts/seller_inference.py,
 *  served as `seller_inferred`) decides first: "agent" marks the listing
 *  when the site called it an owner's, "owner" clears the mark whatever
 *  the seller's count says. Null or "unknown" falls back to the count
 *  rule the backend already folded into `seller_claims_owner` (an owner
 *  label on a seller holding more than three listings). */
export function maybeAgent(l: {
  seller_inferred?: string | null;
  seller_claims_owner?: boolean | null;
}): boolean {
  if (l.seller_inferred === "owner") return false;
  // For "agent" the backend's seller_claims_owner already says whether
  // the site's own label was owner (a site-labelled agent gets no mark).
  return l.seller_claims_owner === true;
}
